import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Paper,
  Typography,
  TextField,
  InputAdornment,
} from "@material-ui/core";

// Contexts
import OrderContext from "../../../../../../context/orders/v1/OrdersContext";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "0.9rem",
  },
  rowBottom: {
    marginBottom: "0.5rem",
  },
  title: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    marginTop: "0.3rem",
  },
}));

const RefundShipping = () => {
  const classes = useStyles();
  const { order, modalValues, modalErrors, setValues, setErrors } =
    useContext(OrderContext);

  const [info, setInfo] = useState(null);

  const handleChange = (e) => {
    const id = e.target.id;
    const value = e.target.value;

    if (id === "shipping") {
      // const max_refund = parseFloat(4.95 - info.refunded);
      const max_refund = parseFloat(info.amount);

      // Regex
      const validPricing = /^[0-9]\.{0,1}[0-9]*$/;

      if (!validPricing.test(value)) {
        modalErrors[id] = "Shipping refund must be a numeric value";
      } else if (parseFloat(value) > max_refund) {
        modalErrors[id] = "Can’t refund more than available";
      } else {
        modalErrors[id] = "";
      }

      setValues({ ...modalValues, [id]: value });
      setErrors(modalErrors);
    }
  };

  useEffect(() => {
    if (order.shipping_lines) {
      let temp = {
        title: order.shipping_lines[0].title,
        amount: order.shipping_lines[0].price,
        refunded: "0.00",
      };

      // Get Total Shipping Refunded
      if (order.refunds.length > 0) {
        order.refunds.map((refund) => {
          refund.transactions.map((each) => {
            if (Math.abs(parseFloat(each.amount)) > 0) {
              temp["refunded"] = Math.abs(parseFloat(each.amount)).toFixed(2);
            }
          });
        });
      }

      setInfo(temp);
    }
  }, []);

  return (
    order.shipping_lines.length > 0 &&
    info && (
      <Grid container direction="column" justifyContent="flex-start">
        <Paper className={classes.paper}>
          <Grid
            item
            container
            xs={12}
            direction="column"
            alignItems="flex-start"
            justifyContent="flex-start"
          >
            <Grid item className={classes.rowBottom}>
              <Typography variant="body1" className={classes.title}>
                Refund shipping{" "}
              </Typography>{" "}
            </Grid>
            <Grid item className={classes.rowBottom}>
              Shipping rate:{" "}
              <strong>
                {" "}
                {info.title}($ {info.amount}){" "}
              </strong>{" "}
            </Grid>
            <Grid item> Refund amount </Grid>{" "}
            <Grid item>
              <TextField
                type="text"
                variant="outlined"
                size="small"
                margin="dense"
                id="shipping"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <span
                        style={{
                          fontSize: "0.9rem",
                        }}
                      >
                        {" "}
                        ${" "}
                      </span>{" "}
                    </InputAdornment>
                  ),
                }}
                placeholder="0"
                value={modalValues.shipping}
                onChange={handleChange}
                error={modalErrors.shipping ? true : false}
                helperText={modalErrors.shipping ? modalErrors.shipping : ""}
              />{" "}
            </Grid>{" "}
            <Grid item>
              <Typography variant="body2">
                {" "}
                {parseFloat(info.refunded) > 0 &&
                  `$${info.refunded} has already been refunded.`}{" "}
              </Typography>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Paper>{" "}
      </Grid>
    )
  );
};

export default RefundShipping;
